export default "__VITE_ASSET__e443c5d2__"